/**
 * Wrapper class for File/uri to maintain original metadata.
 */
export class SelectedFile {
  public readonly name: string;
  public readonly size: number;
  public readonly mimeType: string;
  public readonly file: Blob | string;

  constructor(file: Blob | string, name: string, size: number, mimeType: string) {
    this.file = file;
    this.name = name;
    this.size = size;
    this.mimeType = mimeType;
  }
}
